import { useLDClient } from 'launchdarkly-react-client-sdk';

export const useInventoryLedgerLD = (): boolean => {
  const ldClient = useLDClient();
  return ldClient?.variation('pos.mobile-checkout.inventory-ledger.rollout', false);
};
